var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider-item slider-item--active" }, [
    _c("h2", { ref: "title", staticClass: "slider-item__title" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$t.__("recap.slider.IntroductionSlide.title")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c("img", {
      attrs: {
        src: "/ressources/logged/img/illustrations/recap2024/shape-recap.svg",
        width: "277"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }